export const buildSemanticHighlights = (article) => {
  const occupancy = article?.editorialOccupancy || article?.onlineCentimetragem || {};
  const brandEntity = Array.isArray(occupancy.entityBreakdown)
    ? occupancy.entityBreakdown.find(entity => entity?.type === 'brand')
    : null;
  const spokespersons = [
    occupancy.spokespersonFound,
    brandEntity?.spokespersonFound,
    article?.spokespersonFound
  ].filter(Boolean);
  const keyMessages = [
    ...(Array.isArray(occupancy.keyMessagesFound) ? occupancy.keyMessagesFound : []),
    ...(Array.isArray(brandEntity?.keyMessagesFound) ? brandEntity.keyMessagesFound : []),
    ...(Array.isArray(article?.keyMessagesFound) ? article.keyMessagesFound : [])
  ].filter(Boolean);

  return [
    ...Array.from(new Set(spokespersons)).map(text => ({
      type: 'spokesperson',
      text,
      label: 'Porta-voz'
    })),
    ...Array.from(new Set(keyMessages)).map(text => ({
      type: 'keyMessage',
      text,
      label: 'Mensagem-chave'
    }))
  ];
};

export const getReducedFontSize = (fontSize, ratio = 0.8) => {
  if (!fontSize) return undefined;

  const match = fontSize.match(/([\d.]+)(rem|px|em)?/);
  if (!match) return undefined;

  const value = parseFloat(match[1]);
  const unit = match[2] || 'rem';

  return `${value * ratio}${unit}`;
};

export const buildPublicArticleUrl = (articleId) => {
  if (!articleId || typeof window === 'undefined') {
    return null;
  }

  return `${window.location.origin}/article/${articleId}`;
};
